import type { Specialty } from "../types/auth";
import type { APIInstance } from "./apiService";

export class SpecialtyService {
  private api: APIInstance;

  constructor(api: APIInstance) {
    this.api = api;
  }

  async getSpecialties(): Promise<Specialty[]> {
    type ResponseSpecialty = {
      id: string;
      name: string;
      description: string;
    };
    const response = await this.api.get<ResponseSpecialty[]>("/specialties");
    return response.data.map((specialty) => ({
      specialty_id: specialty.id,
      specialty_name: specialty.name,
      description: specialty.description,
    }));
  }
}
